import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Input, Button, Layout, Icon, Card, Modal } from 'antd'
import { changePassword } from '../../actions'
import error from "../../assets/icons/error-icon.png";
import success from "../../assets/icons/check-icon.png";

// Import CSS
import './ConfirmPassword.scss'

class ConfirmPassword extends Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    loading: false
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({ loading: true })
        const params = {
          current: values.current,
          new_password: values.new_password
        }

        this.props.changePassword(params).then(response => {
          if (response.error) {
            Modal.error({
              title: 'Unable to process the request. Please try again.',
              content: response.message ? `${response.message}.` : null,
              icon: <img src={error} alt="error" />
            })
          } else {
            Modal.success({
              title: 'Success! Your password has been changed. Thank you.',
              content: '',
              icon: <img src={success} alt="success" />,
              onOk: () => this.props.history.push('/user-profile')
            })
            this.props.form.resetFields()
          }
          this.setState({ loading: false })
        })
      }
    });
  };

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback(<p>The new password and confirmation password do not match.</p>);
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { loading } = this.state
    const { form: { getFieldDecorator } } = this.props

    return (
      <Layout>
        <Layout.Content>
          <div className='confirm-password-container'>
            <Card className='card-width'>
              <h1>Change Password</h1>
              <Form onSubmit={this.handleSubmit}>
                <Form.Item label="Current" hasFeedback>
                  {getFieldDecorator('current', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input your current password.',
                      }
                    ],
                  })(<Input.Password />)}
                </Form.Item>
                <Form.Item label="New" hasFeedback>
                  {getFieldDecorator('password', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input your new password.',
                      },
                      {
                        min: 8,
                        message: 'The password must be at least 8 characters.',
                      },
                      {
                        validator: this.validateToNextPassword,
                      },
                    ],
                  })(<Input.Password />)}
                </Form.Item>
                <Form.Item label="Retype New" hasFeedback>
                  {getFieldDecorator('new_password', {
                    rules: [
                      {
                        required: true,
                        message: 'Please retype your password.',
                      },
                      {
                        min: 8,
                        message: 'The password must be at least 8 characters.',
                      },
                      {
                        validator: this.compareToFirstPassword,
                      },
                    ],
                  })(<Input.Password onBlur={this.handleConfirmBlur} />)}
                </Form.Item>
                <Form.Item>
                  <Button className='btn-small btn-primary' loading={loading} style={{ width: "100%" }} htmlType="submit">
                    {loading ? null : "Submit"}
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Layout.Content>
      </Layout >
    );
  }
}


const ConfirmPasswordForm = Form.create({ name: 'confirmPassword_form' })(ConfirmPassword)
function mapStateToProps(state) {
  return {
  }
}
function mapDispatchToProps(dispatch) {
  return {
    changePassword: (data) => dispatch(changePassword(data))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPasswordForm)
